import { api } from 'services/api';
import { createRestProvider } from './restProvider';

const dataProvider = createRestProvider();

interface TransportationApi {
  id: number;
  productCode?: string;
  isActivated?: boolean;
  name?: string;
  nameXhr?: string;
  locality?: string;
  address5?: string;
  productClass?: string;
  classDescription?: string;
  comment?: string;
  description?: string;
  xhr?: string;
  vehicleType?: string;
  guideLanguages?: string[];
  startLocation?: string;
  endLocation?: string;
}

/** Maps the REST shape onto the field names the (Hasura-era) form binds to. */
const fromApi = (item: TransportationApi) => ({
  id: item.id,
  product_code: item.productCode,
  is_active: item.isActivated,
  name: item.name,
  name_xhr: item.nameXhr,
  locality: item.locality,
  address5: item.address5,
  product_class: item.productClass,
  class_description: item.classDescription,
  comment: item.comment,
  description: item.description,
  transportation: {
    id: item.id,
    xhr: item.xhr,
    vehicle_type: item.vehicleType,
    guide: item.guideLanguages || [],
    start_location: item.startLocation,
    end_location: item.endLocation
  }
});

dataProvider.getOne = async ({ id }) => {
  const { data } = await api.get<{ data: TransportationApi }>(
    `/admin/transportations/${id}`
  );
  return { data: fromApi(data) as any };
};

dataProvider.update = async ({ variables, id }) => {
  const values = (variables || {}) as Record<string, any>;
  const transportation = values.transportation || {};

  const { data } = await api.patch<{ data: TransportationApi }>(
    `/admin/transportations/${id}`,
    {
      name: values.name,
      locality: values.locality,
      address5: values.address5,
      productClass: values.product_class,
      classDescription: values.class_description,
      comment: values.comment,
      description: values.description,
      xhr: transportation.xhr,
      vehicleType: transportation.vehicle_type,
      guideLanguages: transportation.guide,
      startLocation: transportation.start_location,
      endLocation: transportation.end_location
    }
  );

  return { data: fromApi(data) as any };
};

export const transportationDataProvider = dataProvider;
